export interface FpsPanelProps {
  onClose: () => void
}
